import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import heroImg from "../../assests/images/hero-img2.png";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { auth } from "../../config/firebase";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const SubjectCard = (props) => {
  const { subject, allow } = props;
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleClick = () => {
    if (allow.allow) {
      navigate("/subject", { state: { lesson: subject } });
    } else {
      handleOpen();
    }
  };

  const goToPdfPage = () => {  
    if (allow.allow) {
      navigate("/tutepage", { state: { lesson: subject } });
    } else {
      handleOpen();
    }
  }
  return (
    <div>
      <Card
        sx={{
          margin: "10px",
          boxShadow: "10px 10px 10px 10px rgba(0,0,0,0.2)",
        }}
      >
        {/* <CardMedia sx={{ height: 240 }} image={heroImg} title="green iguana" /> */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            sx={{
              height: 240,
            }}
            alt="The house from the offer."
            src={subject?.lessonThumbnail || heroImg}
          />
        </Box>
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {subject.lessonName}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {subject.lessonDescription}
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small" onClick={handleClick}>
            Recordings
          </Button>
          <Button size="small" onClick={goToPdfPage}>
            Tutes
          </Button>
        </CardActions>
      </Card>
      <Modal
        keepMounted
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={style}>
          <Typography id="keep-mounted-modal-title" variant="h6" component="h2">
            {allow.msg}
          </Typography>
          {/* <Typography id="keep-mounted-modal-description" sx={{ mt: 2 }}>
            Go to the Sign In page
          </Typography> */}
          <Button
            variant="contained"
            sx={{ marginTop: "10px" }}
            onClick={() => navigate("/")}
          >
            Go to the Home page
          </Button>
        </Box>
      </Modal>
    </div>
  );
};
